import { render, staticRenderFns } from "./QuotationCell.vue?vue&type=template&id=b1b8806a&scoped=true&"
import script from "./QuotationCell.vue?vue&type=script&lang=ts&"
export * from "./QuotationCell.vue?vue&type=script&lang=ts&"
import style0 from "./QuotationCell.vue?vue&type=style&index=0&id=b1b8806a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1b8806a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VDialog,VIcon})
